export function deviationHasFileSizeMetadata(deviation) {
    var _deviation_extended;
    const file = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.originalFile;
    return !!(file && file.filesize && file.width && file.height);
}

//# sourceMappingURL=helpers.js.map